import { gql } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import { t } from 'i18next';
import { useCallback } from 'react';
import { fromError } from '~utils/errors';
import { useRemoveScheduleFromDisplaysMutation } from './__generated__/useRemoveScheduleFromDisplays.graphql';

export function useRemoveScheduleFromDisplays() {
  const toast = useToast();
  const [removeScheduleFromDisplaysMutation, { loading }] = useRemoveScheduleFromDisplaysMutation();

  const removeScheduleFromDisplays = useCallback(
    async (scheduleId: string) => {
      try {
        await removeScheduleFromDisplaysMutation({ variables: { input: { scheduleId } } });
      } catch (err) {
        toast({
          status: 'error',
          title: t('removeScheduleErr'),
          description: fromError(err, 'UpdateSchedule'),
        });
      }
    },
    [removeScheduleFromDisplaysMutation, toast],
  );

  return { removeScheduleFromDisplays, loading };
}

useRemoveScheduleFromDisplays.graphql = {
  fragments: {
    useRemoveScheduleFromDisplays_schedule: gql`
      fragment useRemoveScheduleFromDisplays_schedule on Schedule {
        id
        removingDisplays: displays(filter: { state: REMOVING }) {
          id
        }
      }
    `,
  },
  mutations: {
    RemoveScheduleFromDisplays: gql`
      mutation RemoveScheduleFromDisplays($input: ScheduleRemoveDisplaysInput!) {
        scheduleRemoveDisplays(input: $input) {
          displays {
            id
            schedule {
              schedule {
                id
                title
                ...useRemoveScheduleFromDisplays_schedule
              }
            }
          }
        }
      }
    `,
  },
};
